/**
 * @desc 中转执行
 */
const URL = "/rantion-bus";
import http, { updateResponse } from "@/http";
export function request(body: defs.bus.RequestDto, options?: any) {
  return updateResponse(
    http(URL + `/exchange/execute`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
